import { inject, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';

@NgModule({
  imports: [
    MatIconModule,
  ],
  providers: [
    MatIconRegistry,
  ],
  exports: [
    MatIconModule,
  ],
})
export class IconModule {
  #iconRegistry = inject(MatIconRegistry);
  #sanitizer = inject(DomSanitizer);
  #appBaseHref = inject(APP_BASE_HREF);

  constructor() {
    this.#iconRegistry.addSvgIconSet(this.#sanitizer.bypassSecurityTrustResourceUrl(`${this.#appBaseHref}assets/icons.svg`));
  }
}
